import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { PermissionGuard } from 'app/core/permissions/permissions.guard';
import { TabbedPageLayoutComponent } from 'app/layout/page-layouts/tabbed/tabbed-page-layout.component';

export const financialsRoutes: Route[] = [
    {
        path: 'financials',
        canActivate: [AuthGuard],
        component: LayoutComponent,
        children: [
            {
                path: 'cashier',
                canActivate: [PermissionGuard],
                data: {
                    breadcrumbs: [{ label: 'navigation.financials.cashier' }],
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import(
                                './pages/cashier/cashier.component'
                            ).then((c) => c.CashierComponent),
                    },
                ],
            },
            {
                path: 'transactions',
                canActivate: [PermissionGuard],
                data: {
                    breadcrumbs: [{ label: 'financial.transactions.title' }],
                    actions: [
                        {
                            label: '',
                            icon: 'heroicons_outline:cog-6-tooth',
                            execute: (componentInstance) => {
                                componentInstance.openTableColumnSettings();
                            },
                        }
                    ],
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import(
                                './pages/transactions/transactions.component'
                            ).then((c) => c.TransactionsComponent),
                    },
                ],
            },
            {
                path: 'exchange-log',
                canActivate: [PermissionGuard],
                data: {
                    breadcrumbs: [{ label: 'financial.exchange.title' }],
                    actions: [
                        {
                            label: '',
                            icon: 'heroicons_outline:cog-6-tooth',
                            execute: (componentInstance) => {
                                componentInstance.openTableColumnSettings();
                            },
                        }
                    ],
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import(
                                './pages/exchange-log/exchange-log.component'
                            ).then((c) => c.ExchangeLogComponent),
                    },
                ],
            },
            {
                path: 'verification-queue',
                canActivate: [PermissionGuard],
                data: {
                    breadcrumbs: [
                        { label: 'navigation.players.verification-queue' },
                    ],
                    actions: [
                        {
                            label: '',
                            icon: 'heroicons_outline:cog-6-tooth',
                            execute: (componentInstance) => {
                                componentInstance.openTableColumnSettings();
                            },
                        },
                    ],
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import(
                                '../players/pages/verification-queue/verification-queue.component'
                            ).then((c) => c.PlayerVerificationQueueComponent),
                    },
                ],
            },
            {
                path: 'withdrawals',
                canActivate: [PermissionGuard],
                data: {
                    breadcrumbs: [{ label: 'players.withdrawals.title' }],
                    actions: [
                        {
                            label: '',
                            icon: 'heroicons_outline:cog-6-tooth',
                            execute: (componentInstance) => {
                                componentInstance.openTableColumnSettings();
                            },
                        },
                    ],
                },
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        loadComponent: () =>
                            import(
                                '../players/pages/withdraw-requests/withdraw-requests.component'
                            ).then((c) => c.WithdrawRequestsComponent),
                    },
                ],
            },
        ],
    },
];
